module.exports = __webpack_public_path__ + "img/move.b0fd1978.svg";